// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"44":"2cddaff969c4da47","196":"f6accf0341936e3a","201":"392361802f2fed83","233":"a70631a21c46eca8","354":"0eb25dff30d686eb","402":"7d311303bbcd0181","581":"182e54671620b6c2","628":"42b09370c094f764","775":"d6178ba63faea3d1"}[chunkId] + ".js";
};